import { render } from "./TgProductsModifyComponent.vue?vue&type=template&id=17aad162&scoped=true"
import script from "./TgProductsModifyComponent.vue?vue&type=script&lang=js"
export * from "./TgProductsModifyComponent.vue?vue&type=script&lang=js"

import "./TgProductsModifyComponent.vue?vue&type=style&index=0&id=17aad162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17aad162"]])

export default __exports__